import { configureStore, combineReducers } from "@reduxjs/toolkit";
import reducers from "./reducers";

const rootReducer = combineReducers(reducers);

// 这个store已经集成了redux-thunk和Redux DevTools
const store = configureStore({ reducer: rootReducer });

export default store;
